module.exports = __webpack_public_path__ + "static/lich-263dd6ddb97c4dae108c67386ab85709.png";